import { render } from "./propertiesTriggers.vue?vue&type=template&id=4f973c67"
import script from "./propertiesTriggers.vue?vue&type=script&lang=js"
export * from "./propertiesTriggers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__